import { createTheme } from '@mui/material/styles';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#000',  // Dark bluish-grey background
      paper2: '#000',  // Dark bluish-grey background
      paper: '#000',    // Slightly lighter dark background for paper components
    },
    primary: {
      main: '#00BFFF',     // Cyan/Teal color for primary elements like buttons
    },
    secondary: {
      main: '#1C1C28',     // Darker grey for secondary elements
    },
    text: {
      primary: '#FFFFFF',  // White text for readability
      secondary: '#00BFFF', // Cyan/Teal text for secondary content
    },
  },
  // typography: {
  //   fontFamily: 'Montserrat, Arial, sans-serif', // Set Montserrat as the default font
  // },
  components: {
    MuiSideBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: '#000', // Dark bluish-grey SideBar background
        },
      },
    },
  },
});

export default darkTheme;
